import { FormatDate } from "components/FormatDate";
import { BasicAlert } from "components/Alert";
import { projectFirestore } from "components/ProjectFirestore";

const HistorySave = async (outputUrls, inputFile, appId, appName, appEmail, userName, inputType, outputType, price, email, category) => {
  const createdAt = FormatDate(new Date());
  try {
    const collectionRef = await projectFirestore.collection("users").doc(email).collection("history");
    const values = {
      createdAt,
      appId,
      appName,
      email: appEmail,
      userName,
      inputType,
      outputType,
      inputFile: inputFile,
      outputFile: outputUrls,
      price,
      review: "",
      reviewedAt: "",
      comment: "",
      commentedAt: "",
      visible: true,
      category,
    };
    await collectionRef.add(values);
  } catch (error) {
    console.log(error);
    BasicAlert("히스토리 저장 실패");
  }
};

export default HistorySave;
